import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { UIService } from "@services/ui.service";
import { AuthService } from './auth.service';
import { from, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class S3FileUploadService {

    apiPath: string = 'upload_to_s3';

    constructor(
        private uiService: UIService,
        private httpClient: HttpClient,
        private authService: AuthService
    ) {}

    uploadAvatar(file: File): Promise<string> {
        const filename = `avatar_${Date.now()}.${file.name.split('.').pop()}`;
        const destination = 'avatars';

        return this.uploadToBackend(file, destination, filename);
    }

    uploadDocument(file: File, filename = ''): Observable<any> {
        const s3filename = filename || `document_${Date.now()}.${file.name.split('.').pop()}`;
        const destination = 'documents';

        const promise = this.uploadToBackend(file, destination, s3filename).then((url) => ({
            uri: url,
            filename: s3filename
        }));

        return from(promise);
    }

    getFileAsDataUrl(fileUrl: string): Promise<string> {
        return new Promise((resolve, reject) => {
            fetch(fileUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Failed to fetch the file');
                    }
                    return response.blob();
                })
                .then(blob => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result as string);
                    reader.onerror = () => reject('Failed to convert file to Data URL');
                    reader.readAsDataURL(blob);
                })
                .catch(error => reject(error.message));
        });
    }

    private uploadToBackend(file: File, destination: string, filename: string): Promise<string> {
        let mainDestinationRoot = `users/user_${this.authService.getUserId()}/`;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('filename', filename);
        formData.append('destination', mainDestinationRoot + destination);

        this.uiService.showLoading();
        return new Promise((resolve, reject) => {
            this.httpClient.post(`/${this.apiPath}`, formData).subscribe(
                (response: any) => {
                    this.uiService.hideLoading();
                    if (response?.status === 'success') {
                        resolve(response.data[0]?.url);
                    } else {
                        reject(response?.message || 'Upload failed');
                    }
                },
                (error) => {
                    this.uiService.hideLoading();
                    reject(error);
                }
            );
        });
    }
}
